import { DatePicker, Input } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { CalculatorEntity } from '../../../../store/types/prescription';
import { CALCULATORS_NAMES, CALCULATOR_RESULTS_NAME } from './calculatorsTypes';

export type CalculatorConfig = {
    id: string;
    resultName: CALCULATOR_RESULTS_NAME;
    calculatorName: CALCULATORS_NAMES;
    resultType: string;
    isNewView?: boolean;
};

const STRING_VITALS = new Set(['lb-4630182613']);

export const CalculatorResultsCell: React.FC<{
    containerId?: string;
    vitals?: ReadonlyArray<CalculatorEntity>;
    calculatorConfigData: CalculatorConfig;
    onInputChange: (resultId: string, value: string) => void;
    openCalculatorPopUp: (calc: CalculatorConfig) => void;
}> = ({ vitals, calculatorConfigData, onInputChange, openCalculatorPopUp, containerId }) => {
    const [input, setInput] = useState('');
    const result = vitals?.find((vital) => vital.id === calculatorConfigData.id);

    useEffect(() => {
        setInput(result?.value?.qt || '');
    }, [result]);

    const isStringVital = result && STRING_VITALS.has(result.id);

    return (
        <div className="flex items-center space-x-8 p-8 bg-darwin-neutral-50 rounded-4">
            <p className="font-700 text-darwin-neutral-900">{calculatorConfigData.resultName}</p>
            <div className="flex items-center bg-white text-darwin-neutral-900 border border-darwin-neutral-200 rounded-4">
                <p className={`${isStringVital ? 'max-w-176' : 'max-w-118'} text-14 font-700`}>
                    {calculatorConfigData?.resultType === 'DEFAULT' && (
                        <Input
                            type={isStringVital ? 'string' : 'number'}
                            value={!isStringVital && isNaN(Number(input)) ? '-' : input || ''}
                            onChange={(e) => {
                                setInput(e.target.value);
                            }}
                            width={40}
                            allowClear
                            onPressEnter={(e) => {
                                e.currentTarget.blur();
                            }}
                            onBlur={(e) => {
                                onInputChange(calculatorConfigData?.id, e?.target?.value);
                            }}
                            className={'border-none'}
                        />
                    )}
                </p>

                {calculatorConfigData?.resultType === 'DATE' && (
                    <DatePicker
                        getPopupContainer={() => {
                            return containerId
                                ? (document.getElementById(containerId) as HTMLElement)
                                : document.body;
                        }}
                        picker={'date'}
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        value={input ? moment(input) : null}
                        onChange={(t) => {
                            onInputChange(
                                calculatorConfigData?.id,
                                t?.format("DD MMM'YY")?.toString() || '',
                            );
                        }}
                        allowClear={true}
                        format="DD MMM'YY"
                        className={'border-none'}
                    />
                )}
                <p
                    onClick={() => openCalculatorPopUp(calculatorConfigData)}
                    className="px-8 py-4 text-13 underline border-l border-darwin-neutral-200 cursor-pointer"
                >
                    Calculate
                </p>
            </div>
        </div>
    );
};
